import { render, staticRenderFns } from "./_Resources.vue?vue&type=template&id=3b952dc8&"
import script from "./_Resources.vue?vue&type=script&lang=js&"
export * from "./_Resources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports